import React from 'react';
import styled from 'styled-components';
import DayPicker, { DateUtils, LocaleUtils, } from 'react-day-picker';
import { defaultColors, AngleLeftIcon, AngleRightIcon, Box, ButtonSize, getInset, SecondaryButton, } from '@lifechurch/react-ion';
export const Wrapper = styled(Box) `
  padding-block-start: 16px;
  padding-block-end: 16px;
  padding-inline-start: 16px;
  padding-inline-end: 0;
  box-shadow: ${props => props.theme.shadows[1]};
  border-radius: 4px;
  position: relative;
  display: inline-block;
  background: ${(props) => props.theme.colors.white};
  direction: ltr;

  * {
    outline: none;
  }

  .DayPicker {
    color: ${(props) => props.theme.colors.gray100};
  }

  .DayPicker-wrapper {
    padding: 0;
  }

  .DayPicker-Month {
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 16px;
  }

  .DayPicker-Weekday {
    padding: 0.5rem 0;
  }

  .DayPicker-Weekdays abbr {
    font-size: 13.44px;
    color: ${(props) => props.theme.colors.gray50};
  }

  .DayPicker-Day {
    font-size: 13.44px;
    height: 32px;
    width: 32px;
    padding: 0;
    outline: none;
    cursor: default;
    position: relative;
    &:not(.DayPicker-Day--selected):not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
      color: #4facf4;
      background-color: #e5f2fc;
    }
  }

  .DayPicker-Caption {
    text-align: center;
    font-size: 16px;
    line-height: 20px;
    font-weight: normal;
    margin-block-end: 12px;
  }

  .DayPicker-Day--today {
    color: ${(props) => props.theme.colors.gray100};
    font-weight: normal;
  }

  .DayPicker-Day--disabled {
    color: ${(props) => props.theme.colors.gray30};
  }

  .DayPicker-Day--outside {
    color: ${(props) => props.theme.colors.gray30};
  }

  .DayPicker-Day--start:before {
    border-radius: 16px 0 0 16px;
  }

  .DayPicker-Day--end:before {
    border-radius: 0 16px 16px 0;
  }

  .DayPicker-Day--start:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):before,
  .DayPicker-Day--end:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):before {
    display: block;
    content: '';
    ${getInset('insetBlockStart', 0)};
    ${getInset('insetBlockEnd', 0)};
    ${getInset('insetInlineStart', 0)};
    ${getInset('insetInlineEnd', 0)};
    position: absolute;
    z-index: -1;
    background-color: #e5f2fc;
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    color: ${(props) => props.theme.colors.white};
    background-color: ${(props) => props.theme.colors.brands.open};
  }

  .Range
    .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
    background-color: #e5f2fc;
    color: ${(props) => props.theme.colors.gray100};
    border-radius: 0;
  }
`;
const BaseNavigation = styled.button `
  position: absolute;
  padding: 12px;
  ${getInset('insetBlockStart', '-12px')};
  background: none;
  border: none;
  outline: none;
  line-height: 0;

  svg {
    opacity: 0.5;
  }

  &:hover svg {
    opacity: 1;
  }
`;
const LeftNavigation = styled(BaseNavigation) `
  left: -12px;
`;
const RightNavigation = styled(BaseNavigation) `
  right: 4px;
`;
export const Calendar = ({ fromMonth = new Date(), zIndex, button, ...props }) => (React.createElement(Wrapper, { zIndex: zIndex },
    React.createElement(DayPicker, { showOutsideDays: true, navbarElement: React.createElement(Navbar, null), fromMonth: fromMonth, disabledDays: [
            {
                before: fromMonth,
            },
        ], ...props }),
    button && (React.createElement(SecondaryButton, { type: 'button', size: ButtonSize.SM, onClick: button.onClick, display: 'block', marginBlockStart: '8px', marginBlockEnd: 0, marginInlineStart: 'auto', marginInlineEnd: '16px', disabled: button.disabled }, button.text))));
const Navbar = ({ onPreviousClick, onNextClick, }) => (React.createElement(React.Fragment, null,
    React.createElement(LeftNavigation, { type: 'button', onClick: () => onPreviousClick && onPreviousClick() },
        React.createElement(AngleLeftIcon, { color: defaultColors.gray100 })),
    React.createElement(RightNavigation, { type: 'button', onClick: () => onNextClick && onNextClick() },
        React.createElement(AngleRightIcon, { color: defaultColors.gray100 }))));
export { DateUtils, LocaleUtils };
